export class FnGridRow {
	isSelected: boolean;
	data: object; // object.compareTo-- we have the row for comparision
	rowID: any;
	rowIndex: number;
	uniqueId: string;

	constructor(data: any, rowIndex: number, uniqueId: string) {
		this.isSelected = false;
		this.data = data;
		this.rowIndex = rowIndex;
		this.uniqueId = uniqueId;
	}
}
